import {Box, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from "@mui/material";
import {CampaignPhoneNumberRow} from "./CampaignPhoneNumberRow";
import {headerCellSx} from "../../constants";

const columns = ["Phone number", "Status", "Attempts", "Last queued", "Last called", "Last conversation", "Updated"];

export const CampaignPhoneNumbersTable = ({
  rows, total, loading, page, rowsPerPage, onPageChange, onRowsPerPageChange,
  maxAttempts, projectId, callingId, onCall, onShowAttempts, onDelete
}) => {
  return (
    <Box sx={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
      <Box sx={{flex: 1, overflowY: "auto"}}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {columns.map(column => <TableCell key={column} sx={headerCellSx}>{column}</TableCell>)}
              <TableCell padding="checkbox" sx={headerCellSx}/>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <CampaignPhoneNumberRow
                key={row.id}
                row={row}
                maxAttempts={maxAttempts}
                projectId={projectId}
                calling={callingId === row.id}
                onCall={onCall}
                onShowAttempts={onShowAttempts}
                onDelete={onDelete}
              />
            ))}
            {rows.length === 0 &&
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center" sx={{py: 6, color: "text.secondary"}}>
                  {loading ? "Loading..." : "No phone numbers"}
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </Box>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(e, newPage) => onPageChange(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
        rowsPerPageOptions={[20, 50, 100]}
      />
    </Box>
  )
}
